import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {NavigationService} from "../navigation/navigation.service";
import {DetailService} from "./detail.service";


/**
 * Class StandaloneDetailResolver
 * @desc Klasse, die Detailconfig und -content laedt wenn Detailansicht direkt aus Hauptmenue heraus aufrufbar ist
 */
@Injectable()
export class StandaloneDetailResolver
{

    /**
     * Function > constructor
     * @param {DetailService} OBJ_detail_service
     * @param OBJ_navigation_service
     */
    constructor(
        private OBJ_detail_service: DetailService,
        private OBJ_navigation_service: NavigationService
        )
    {} // end function constructor


    /**
     * Function > resolve
     * @param {ActivatedRouteSnapshot} OBJ_route
     * @param OBJ_state
     * @return {Observable<any>}
     */
    resolve(OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot)
    {

        let STR_route_submenu = OBJ_route.paramMap.get("route_submenu");

        let STR_route_menu = OBJ_route.parent.paramMap.get("route_menu");

        let STR_config_endpoint = this.OBJ_navigation_service.getDetailConfigEndpointByRoute(STR_route_menu, STR_route_submenu);

		let STR_content_endpoint = this.OBJ_navigation_service.getDataEndpointByRoute(STR_route_menu, STR_route_submenu);

		let OBJ_http_content_params = this.OBJ_navigation_service.getDataEndpointParamsByRoute(STR_route_menu, STR_route_submenu);

		// Eventuell muss die Route noch angepasst werden
        if(OBJ_route.paramMap.get("id"))
        {
            STR_content_endpoint = STR_content_endpoint.replace(":id", OBJ_route.paramMap.get("id"));
        } // end if

		// Es gibt Detailansichten, die keine Daten vom Backend benoetigen (reine iFrame-Anbindungen)
		if(!STR_content_endpoint)
		{
			return this.OBJ_detail_service.getFormConfig(STR_config_endpoint);
		} // end if

		return this.OBJ_detail_service.getFormFields(STR_config_endpoint, STR_content_endpoint, OBJ_http_content_params);

    } // end function resolve


} // end class StandaloneDetailResolver
